import statisticsListPage from '@/pages/statistics/ListPage'

export default [
  {
    path: '/statistics/list',
    name: 'StatisticsList',
    component: statisticsListPage,
  },
]
